
import { PropTypes } from 'prop-types';

const Iframe = (props) => {
  const { id, source, height, width } = props;
  return (
    <iframe id={id} src={source} height={height} width={width} />
  );
};

Iframe.propTypes = {
  id: PropTypes.string,
  source: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number
};

export default Iframe;
